import { NgModule } from '@angular/core';
import { LoginPage } from './pages/login/login.page';
import { AuthRoutingModule } from './auth-routing.module';
import { LogoutPage } from './pages/logout/logout.page';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  declarations: [
    LoginPage,
    LogoutPage,
  ],
  imports: [
    AuthRoutingModule,
    SharedModule,
  ],
  exports: [],
})
export class AuthModule { }
